import gql from "graphql-tag";

import type {Result} from "@khanacademy/wonder-blocks-data";
import {useFastlyQuery} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    StandardRegionPresentationsQuery,
    StandardRegionPresentationsQueryVariables,
} from "./__graphql-types__/StandardRegionPresentationsQuery.ts";

export const STANDARD_REGIONS_PRESENTATIONS_QUERY: GqlOperation<
    StandardRegionPresentationsQuery,
    StandardRegionPresentationsQueryVariables
> = gqlOp(gql`
    query StandardRegionPresentationsQuery(
        $countrySlug: String!
        $regionSlug: String!
        $countryAndRegionSlug: String!
        $isDiscoverable: Boolean
    ) {
        standardRegions(
            isDiscoverable: $isDiscoverable
            slug: $countryAndRegionSlug
        ) {
            error {
                code
                debugMessage
            }
            standardRegion {
                id
                imageUrl
                isDiscoverable
            }
        }
        standardRegionPresentations(
            countrySlug: $countrySlug
            regionSlug: $regionSlug
        ) {
            id
            presentationSections {
                courses {
                    id
                    relativeUrl
                    standaloneTitle
                }
                setOfStandardsId
                displayName
                rootStandards {
                    displayName
                    standardId
                    relativeUrl
                }
            }
        }
    }
`);

export const useStandardRegionPresentationsQuery = (
    countrySlug: string,
    regionSlug: string,
    countryAndRegionSlug: string,
    isDiscoverable?: boolean | null,
): Result<StandardRegionPresentationsQuery> => {
    return useFastlyQuery(STANDARD_REGIONS_PRESENTATIONS_QUERY, {
        variables: {
            countrySlug,
            regionSlug,
            countryAndRegionSlug,
            isDiscoverable,
        },
    });
};
